import { FigmaImage, PanesContainer, useNotionDatabase } from "dev";
import { ProgressBar } from "ui/delivery";

import { Status, Substatus } from "@/src/types";

export default function LegacyFulfillmentProgressBars() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  if (!db) return null;

  const data = db
    .map((r) => {
      const status = r["Status"] as Status;
      const substatus = r["Sub-status"] as Substatus<Status>;
      const figma_url = r["Legacy Fulfillment Figma Link"];

      return { status, substatus, figma_url };
    })
    .filter((r) => !!r.figma_url);

  return (
    <PanesContainer
      items={data}
      renderItem={({ status, substatus, figma_url }) => (
        <>
          <>
            <span>status: {status}</span>
            <span>substatus: {substatus}</span>
          </>

          <FigmaImage url={figma_url} />

          <ProgressBar
            status={status}
            substatus={substatus}
            carrier="merchant"
          />
        </>
      )}
    />
  );
}
